import React, { useState, useRef } from 'react';
import UpdateDateTimeModal from './modal/UpdateDateTimeModal';
import { formatDateForString } from 'utils/formatter';
import { getUserBroker, refreshMoneytree } from 'config/api';

import * as api from 'config/api';

type UpdateDateTimeProps = {
  brokers: Array<api.GetUserBrokerResultItem> | undefined;
  updateBrokers: (brokers: api.GetUserBrokerResultItem[]) => void;
};

export const UpdateDateTimeInternal: React.FC<UpdateDateTimeProps & {
  textClassName: string;
}> = props => {
  const { brokers, updateBrokers } = props;
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateBrokersState, setUpdateBrokersState] = useState<
    api.GetUserBrokerResultItem[]
  >([]);
  const [beInRefresh, setBeInRefresh] = useState<boolean>(false);
  const unmounted = useRef<boolean>(false);

  const refresh = (): void => {
    if (!beInRefresh) {
      setBeInRefresh(true);
      refreshMoneytree().then(ret => {
        getUserBroker().then(ret => {
          !unmounted.current && setBeInRefresh(false);
          !unmounted.current && ret && setUpdateBrokersState(ret.Items);
          !unmounted.current && ret && updateBrokers(ret.Items);
        });
      });
    }
  };

  const onUpdateClick = (): void => {
    refresh();
    setShowUpdateModal(true);
  };

  const onClose = (): void => setShowModal(false);
  const onUpdateClose = (): void => setShowUpdateModal(false);

  const updDateTime = brokers?.reduce(
    (prev, current) => (prev.UpdTime < current.UpdTime ? current : prev),
    { UpdTime: '' }
  )?.UpdTime;

  return (
    <div className="ml-auto" onClick={() => showModal && onClose()}>
      {showUpdateModal === true && (
        <UpdateDateTimeModal
          brokers={updateBrokersState}
          onClose={onUpdateClose}
          beInRefresh={beInRefresh}
        />
      )}

      <div
        className={`pr-4 pb-4 flex items-center justify-end text-xs cursor-pointer ${props.textClassName}`}
        onClick={onUpdateClick}>
        <span className="mr-1">
          {formatDateForString(updDateTime, 'yyyy/MM/dd(ddd) HH:mm')}
        </span>
        <span className="mr-2">更新</span>
        {brokers?.length !== 0 ? (
          <div className="text-sm">
            <div className="icon-reflesh"></div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

const UpdateDateTime: React.FC<UpdateDateTimeProps> = props => {
  return <UpdateDateTimeInternal {...props} textClassName="text-white" />;
};

export default UpdateDateTime;
